// Copies text to the clipboard, returning success instead of throwing on a denied write (RMS-FRONTEND-11N).
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
